import * as Yup from 'yup';
import { OptionalObjectSchema } from 'yup/lib/object';

export const screenAndProtectDetailsSchema = () => ({
  agreeToTerms: Yup.boolean().oneOf([true]).required(),
  agreeToPrivacy: Yup.boolean().oneOf([true]).required(),
  selectedProperties: Yup.array().of(Yup.string()).required(),
});

export type ScreenAndProtectDetailsFormSchemaType = Yup.InferType<
  OptionalObjectSchema<ReturnType<typeof screenAndProtectDetailsSchema>>
>;
